<template>
    <div>
        <div v-for="(line, linePosition) in localPhoneNumbers" v-bind:key="linePosition">
            <v-row>
                <v-col cols="12" md="5">
                <vue-tel-input-vuetify
                    v-model="line.phone_number"
                    data-testid="new-contact-phone-number"
                    required
                    :label="$t('contacts.columns.phoneNumber')"
                    :rules="phoneRules"
                    :defaultCountry="defaultCountry"
                    :onlyCountries="supportedCountries"
                    mode="international"
                    placeholder=''
                    @input="updateLine(linePosition, line)"
                ></vue-tel-input-vuetify>
                </v-col>
                <v-col cols="12" md="2">
                <v-text-field
                    v-model="line.extension"
                    label="Extension"
                    :rules="extensionRules"
                    @input="updateLine(linePosition, line)"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                <v-text-field
                    v-model="line.label"
                    :rules="labelRules"
                    label="Label"
                    @input="updateLine(linePosition, line)"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mt-4 mr-4">
                <v-btn
                    text
                    color="red"
                    icon
                    :disabled="linePosition===0"
                    @click="deleteLine(linePosition)"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                </v-col>
                <v-col cols="12" md="1" class="mt-4">
                <v-btn
                    text
                    color="primary"
                    icon
                    @click="addLine()"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-form-fields-mainTab-phoneNumbers',
  data () {
    return {
      supportedCountries: ['CA', 'US', 'AU'],
      localPhoneNumbers: [],
      labelRules: [
        v => (v?.length === 0 || v?.length >= 2) || this.$t('contacts.formValidation.minimumChar', { min: 2 })
      ],
      phoneRules: [
        v => !!v || this.$t('contacts.formValidation.required'),
        v => (v && v?.length >= 9) || this.$t('contacts.formValidation.minimumDigit', { min: 9 })
      ],
      extensionRules: [
        v => (v === undefined || v === null || v?.length === 0) || (v?.length > 0 && /^[0-9]*$/.test(v)) || this.$t('contacts.formValidation.numericOnly')
      ]
    }
  },
  computed: {
    ...mapGetters({
      contact: 'contacts/form/contact',
      defaultCountry: 'sipua/country'
    }),
    phoneNumbers: { get () { return this.contact?.phoneNumbers }, set (phoneNumbers) { this.setPhoneNumbers(phoneNumbers) } }
  },
  watch: {
    phoneNumbers: {
      handler (newVal) {
        // deep clone to avoid inheriting vuex watchers
        this.localPhoneNumbers = newVal.map(item => ({ ...item }))
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setPhoneNumbers: 'contacts/form/setPhoneNumbers'
    }),

    addLine () {
      this.phoneNumbers = [...this.phoneNumbers, { phone_number: '', extension: '', label: '' }]
    },

    deleteLine (linePosition) {
      this.phoneNumbers = this.phoneNumbers.filter((item, index) => index !== linePosition)
    },

    updateLine (index, phoneNumber) {
      this.phoneNumbers = this.localPhoneNumbers.toSpliced(index, 1, phoneNumber)
    }
  }
}
</script>

<style>

</style>
